import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PageProps } from '../types';
import Navigation from '../pages/old_strategic_performance/components/Navigation';
import '../pages/old_strategic_performance/index.css';
import { OldStrategicPerformanceStateProvider } from '../pages/old_strategic_performance/contexts/OldStrategicPerformanceStateContext';

interface OldStrategicPerformanceLayoutProps {
  children: React.ReactNode;
  pages: PageProps[];
}

const OldStrategicPerformanceLayout: React.FC<OldStrategicPerformanceLayoutProps> = ({ children, pages }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);
  const [activePageTitle, setActivePageTitle] = useState('Old Strategic Performance');
  const location = useLocation();
  const { user } = useAuth();

  const pagePropsList: PageProps[] = pages.map((page) => ({
    title: page.title,
    icon: page.icon || null,
    tabs: page.tabs,
    path: page.path,
    show: page.show,
    element: page.element
  }));

  useEffect(() => {
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  // Automatically detect active page based on location
  useEffect(() => {
    if (location.pathname.startsWith('/old-strategic-performance')) {
      const activePage = pagePropsList.find(page => 
        page.path === '/old-strategic-performance/' || 
        location.pathname.startsWith(page.path.replace('/*', '').replace(/\/$/, ''))
      );
      if (activePage && activePage.title === 'Old Strategic Performance') {
        setActivePageTitle(activePage.title);
      }
    }
  }, [location.pathname, pagePropsList]);

  const handlePageChange = (title: string) => {
    setActivePageTitle(title);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <OldStrategicPerformanceStateProvider>
    <div className="strategic-performance-module">
      <Box sx={{
        display: 'flex',
        height: '100vh',
        overflow: 'hidden',
        bgcolor: '#F9FAFB'
      }}>
        <Sidebar
          isOpen={isSidebarOpen}
          onToggle={toggleSidebar}
          activePageTitle={activePageTitle}
          onPageChange={handlePageChange}
          pagePropsList={pagePropsList}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            transition: theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: isSidebarOpen ? '310px' : '64px',
            height: '100vh',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            '@media (max-width: 600px)': {
              marginLeft: isSidebarOpen ? '0' : '64px',
              width: '100%',
            },
          }}
        >
          <Navigation />
          <Box sx={{ flex: 1, overflow: 'auto' }}>
            {children}
          </Box>
        </Box>
      </Box>
    </div>
    </OldStrategicPerformanceStateProvider>
  );
};

export default OldStrategicPerformanceLayout;

